module.exports = __webpack_public_path__ + "img/rain-forest.fd209956.gif";